<template src="./index.html"></template>

<script>
	import {
		getdata
	} from './data.js';
	import com from '../../../../../comMapping.js';
	import PropertyFrame from './PropertyFrame/index.vue';
	import ExcisePayer from './ExcisePayer/index.vue';
	export default {
		components: {
			PropertyFrame,
			ExcisePayer
		},
		data() {
			return {
				showdelete: true,
				detail: {
					updateTime: "",
					identificationCode: "上海速元数字科技有限公司",
					taxpayerName: "9310000MA7FNAFHOA",
					taxpayerType: "1",
					effectiveDateEnd: "",
					billPayerStatus: "03",
					financialOfficer: "",
					legalPersonName: "王继章",
					registerAddressTel: "02-99950",
					productionAddress: "江湾城路99弄8号楼901室",
					account: "121925424410906",
					accountName: "招商银行上海五角场支行",
					registerType: "173",
					registerAddressPostalCode: "",
					districtTaxAuthorityCode: "31002020000",
					industryCode: "52501",
					taxAuthorityName: "国色剿彪穿家铬癌榜瘪疮铂便务总局上海市税务局",
					taxAuthorityCode: "31002020000",
					exitEnterpriseType: "",
					enterpriseLogo: "Y",
					bankDot: "",
					mechanismType: "",
					taxFileNumber: "",
					registerNumber: "10211502010000752",
				},
				consumptionPayerTypeList: [],
				natureOfEnterprises: [{
					natureOfEnterprise: "01",
					effectiveDateEnd: "2022-01-10"
				}, {
					natureOfEnterprise: "02",
					effectiveDateEnd: "2022-01-11"
				}, {
					natureOfEnterprise: "03",
					effectiveDateEnd: "2022-01-12"
				}, {
					natureOfEnterprise: "04",
					effectiveDateEnd: "2022-01-13"
				}, {
					natureOfEnterprise: "05",
					effectiveDateEnd: "2022-01-14"
				}],
				comMapping: com,
				//企业行业性质弹框
				PropertyFrameTk: false,
				//消费税纳税人类型弹框
				ExcisePayerTk: false
			};
		},
		mounted() {},
		created() {
			this.initialization();
		},
		methods: {
			//企业行业性质弹框回调
			PropertyFrameTkclosediag() {
				this.PropertyFrameTk = false;
			},
			ExcisePayerTkclosediag() {
				this.ExcisePayerTk = false;
			},
			//更新基本信息
			UpdateBasicInformation() {
				this.$https.fetchPost('/natural/basicInfo/updateNaturalBaSicInfo').then(res => {
					if (res.data.code == '200') {
						this.$message.success(res.data.message);
						this.initialization();
					} else {
						this.$message.error('更新基本信息出错：'+res.data.message);
					}
				});
			},
			forhideendelete() {
				this.showdelete = false;
			},
			forRouter() {},
			//时间撮转时间
			timestampToTimesfm(timestamp) {
				if (timestamp) {
					// 时间戳为10位需*1000，时间戳为13位不需乘1000
					var date = new Date(timestamp);
					var Y = date.getFullYear() + '-';
					var M = (date.getMonth() + 1 < 10 ? date.getMonth() + 1 : date.getMonth() + 1) + '-';
					var D = (date.getDate() < 10 ? date.getDate() : date.getDate()) + ' ';
					var h = date.getHours() + ':';
					var m = date.getMinutes() + ':';
					var s = date.getSeconds();
					// return Y + M + D + h + m + s;
					return Y + M + D;
				}
			},
			//初始化
			initialization() {
				this.$https.fetchPost('/natural/basicInfo/findNaturalBasicInfo').then(res => {
					if (res.data.code == '200') {
						this.detail = res.data.data.detail;
						this.consumptionPayerTypeList = res.data.data.consumptionPayerTypeList;
						this.natureOfEnterprises = res.data.data.natureOfEnterprises;
					} else {
						this.$message.error(res.data.message);
					}
				});
			}
		}
	};
</script>

<style scoped lang="less">
	@import url('./index.less');
</style>